export enum PartnerResellerIds {
    lexisNexis = 1,
    burrelles = 3,
    kantar = 4,
    unicepta = 5,
    newsdirect = 6,
    paMedia = 7,
    refmedia = 8,
}
